import { render, staticRenderFns } from "./FileAttachElement.vue?vue&type=template&id=090007ba&scoped=true&"
import script from "./FileAttachElement.vue?vue&type=script&lang=js&"
export * from "./FileAttachElement.vue?vue&type=script&lang=js&"
import style0 from "./FileAttachElement.vue?vue&type=style&index=0&id=090007ba&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "090007ba",
  null
  
)

export default component.exports